<template>
<tr
v-if="$vuetify.breakpoint.mdAndUp"
:class="['status-'+status, {flicker: isRecent}]"
>
	<!-- Row actions go in the first column -->
	<td data-actions="true">
		<v-btn flat icon @click.native.stop="showActions">
			<v-icon small>fa-ellipsis-v</v-icon>
		</v-btn>
	</td>

	<!-- Visible details are displayed as/in columns -->
	<td v-for="column in columns"
	:data-label="column.label">
		<jm-cell
		:entity="entity"
		:view="column"
		></jm-cell>
	</td>
</tr>

<div
v-else
>
	<v-card @contextmenu="showActions">
		<v-card-title v-if="entity.type == 'journey'">
			<v-layout column>
				<v-layout row xs12>
					<v-flex xs1>
						<v-icon small>fa-map-marker-alt</v-icon>
					</v-flex>
					<v-flex xs10 align-start>
						{{ entity.origin() }} → {{ entity.destination() }}
					</v-flex>
				</v-layout>
				<v-layout row xs12>
					<v-flex xs1>
						<v-icon small>fa-clock</v-icon>
					</v-flex>
					<v-flex xs10 align-start>
						{{ entity.departure() |timestamp }} → {{ entity.arrival() |timestamp }}
					</v-flex>
					<v-flex xs1 class="text-xs-center" @click="detailsVisible = !detailsVisible">
						<v-icon small>{{ detailsVisible ? 'fa-chevron-up' : 'fa-chevron-down' }}</v-icon>
					</v-flex>
				</v-layout>
			</v-layout>
		</v-card-title>
		<v-card-title v-else>
			<v-layout column>
				<v-layout row xs-12>
					<v-flex xs11 align-start>
						{{ entity.displayName() }}
					</v-flex>
					<v-flex xs1 class="text-xs-center">
						<v-layout column>
							<v-flex>
								<jm-row-actions :row="this"></jm-row-actions>
							</v-flex>
							<v-flex class="text-xs-center" @click="detailsVisible = !detailsVisible">
								<v-icon small>{{ detailsVisible ? 'fa-chevron-up' : 'fa-chevron-down' }}</v-icon>
							</v-flex>
						</v-layout>
					</v-flex>
				</v-layout>
			</v-layout>
		</v-card-title>
		<v-card-text v-show="detailsVisible">
			<v-layout column v-for="(column, index) in allFields" :key="index">
				<v-layout row xs12 class="text-cs-left">
					<small>{{ column.label }}</small>
				</v-layout>
				<v-layout row xs12 justify-end>
						<jm-cell
						:entity="entity"
						:view="column"
						></jm-cell>
				</v-layout>
			</v-layout>
		</v-card-text>
	</v-card>
	<v-divider></v-divider>
</div>

</template>

<script>
import moment from 'moment'
import { ModelTableView } from '@/assets/js/ModelView'
import JmRowActions from './RowActions'
import JmCell from './Cell'

export default {
	name: "JmRow",

	props: {
		entity: Object,
		view: Object
	},

	data () {
		return {
			detailsVisible: false
		}
	},

	computed: {

		allFields () {
			return [
				... this.columns,
				... this.details
			].filter(i => i.value(this.entity) && !i.subgroup);
		},

		columns () {
			return this.view.visibleProperties();
		},

		details () {
			return this.view.hiddenProperties();
		},

		status () {
			return "";
		},

		isRecent () {
			return false;
		},

		numColumns () {
			return this.columns.length;
		}

	},

	methods: {

		showActions (e) {
			this.$store.commit('dialogue/actions/toggle', [ this.entity, e.clientX, e.clientY ]);
		},

		toggleDetails () {
			this.detailsVisible = !this.detailsVisible;
		},


		notEmpty (view) {
			const value = view.value(this.entity);

			return value instanceof ModelTableView
				? value.values(this.entity).some(i => i !== undefined)
				: value !== undefined;
		}
	},

	filters: {
		timestamp (tstamp) {
			const ts = moment(tstamp)
			return ts.isValid()
				? ts.isSame(Date.now(), "day")
					? ts.format("HH:mm")
					: ts.format("YYYY-MM-DD HH:mm")
				: "";
		}
	},

	components: {
		JmCell,
		JmRowActions
	}
};
</script>

<style lang="stylus" scoped>
</style>



// WEBPACK FOOTER //
// src/components/widgets/Row.vue